import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AddBoxIcon from '@material-ui/icons/AddBox';
import EditIcon from '@material-ui/icons/Edit';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from '../../CustomHooks/useFetch';
import Paper from '@material-ui/core/Paper';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import useOptionGroups from '../OptionGroups/useOptionGroups';
import AddOrEditOptionGroup from '../OptionGroups/AddOrEditOptionGroup';
import IconButton from '@material-ui/core/IconButton';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import {capitalizeFirstLetter} from '../../Util/StringFunctions';



export default function OptionGroupsList(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [optionGroupId, setOptionGroupId] = useState(-1);
    const [getOptionGroupsHookResponse, getOptionGroupsHook, deleteOptionGroupHook, deleteOptionGroupHookResponse] = useOptionGroups();
    const [translateGui] = useGuiTranslations();

    useEffect(
        () => {



            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: 4,
                        b: 7,
                    },
                }
            )
        }, []
    );


    

    useEffect(
        () => {
            if (!Array.isArray(deleteOptionGroupHookResponse)) {
                getOptionGroupsHook();
            }
        }, [deleteOptionGroupHookResponse]
    )

    return (
        <Paper elevation={3} style={{ padding: '10px', marginBottom: '30px' }}>
            <div className={classes.flex}>
                <span className={classes.title}> {capitalizeFirstLetter(translateGui(7))}</span>
                <IconButton color="primary" aria-label="add option group" component="span" onClick={() => setOptionGroupId(0)}>
                    <AddBoxIcon />
                </IconButton>
            </div>
            <table className={classes.table}>
                <thead>
                    <tr>
                        <th>
                        {capitalizeFirstLetter(translateGui(35))}
            </th>
                        <th>
                        {capitalizeFirstLetter(translateGui(46))}
            </th>

                    </tr>
                </thead>
                <tbody>
                    {
                        getOptionGroupsHookResponse && getOptionGroupsHookResponse.foodOptionGroups != null ?
                            getOptionGroupsHookResponse.foodOptionGroups.map(
                                (optionGroup, index) =>
                                    <tr key={index} >
                                        <td >
                                            <IconButton className={classes.iconButton}  aria-label="upload picture" component="span" onClick={() => setOptionGroupId(optionGroup.id)}>
                                                <EditIcon   ></EditIcon>
                                            </IconButton>
                                            <IconButton className={classes.iconButton}  aria-label="upload picture" component="span"  onClick={() => deleteOptionGroupHook(optionGroup.id)}>
                                                <DeleteOutlineIcon ></DeleteOutlineIcon>
                                            </IconButton>
                                            
                                        </td>
                                        <td>
                                            {optionGroup.optionGroupName}
                                        </td>
                                    </tr>
                            )
                            : null
                    }
                </tbody>
            </table>
            {
                optionGroupId > -1 ?
                    <AddOrEditOptionGroup
                        optionGroupId={optionGroupId}
                        //setSelectedOptionGroupIdAndCloseOptionGroupForm={props.setSelectedOptionGroupIdAndCloseOptionGroupForm}
                        closeForm={() => { setOptionGroupId(-1); getOptionGroupsHook(); }} />
                    : null
            }
        </Paper>

    )
}

const useStyles = makeStyles({
    table: {
        width: '100%',
        '& td': {
            padding: '10px 0',
            borderBottom: '1px solid rgba(224, 224, 224, 1)',
        },
        '& td:nth-child(1)': {
            textAlign: 'center',
        },
        '& th:nth-child(n+2)': {
            textAlign: 'left',
        },
        '& th': {
            padding: '20px 0',
            borderBottom: '1px solid rgba(224, 224, 224, 1)',
        }
    },
    cursor: {
        cursor: 'pointer',
    },
    flex: { "display": "flex", "alignItems": "center", "justifyContent": "space-between", margin: '30px 10px 50px 10px' },
    title: { fontSize: '1.4rem', fontWeight: 500, },
    addIcon: { color: '#5dbcd2' },
    iconButton: {color:'black'},

});